import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import OurProjects from './pages/OurProjects';
import ContactUs from './pages/ContactUs';
import Gallery from './pages/Gallery';
import Covid19 from './pages/Covid19';
import Donate from './pages/Donate';
import Volunteer from './pages/Volunteer';

function App() {
  return (
    <div className="App">
      <Router basename='/'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/projects" element={<OurProjects />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/covid19" element={<Covid19 />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/volunteer" element={<Volunteer />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
